import React, { useEffect, useState } from 'react'
import { ActionSheet, Modal } from 'antd-mobile'
import MessageList from './MessageList'
import general, { redux } from '../../../general'
import Dialog from '../../../lib/Dialog'
import './css/message.css'

export default function MessagesType(props) {

  const [array, setArray] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)
  const [visible, setVisible] = useState(false)

  const actions = [
    {
      text: '一键已读', key: 'edit', onClick: async () => {
        oneClickOperateMess(1)
      }
    },
    {
      text: '一键删除', key: 'save', onClick: async () => {
        deleteAlert()
      },
    },
  ]

  const deleteAlert = () => {
    Modal.show({
      title: '温馨提示',
      closeOnMaskClick: true,
      className: 'game-sign-title',
      content: (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <div style={{ fontSize: 12, color: '#666', padding: 5 }}>确认删除吗?</div>
          <div onClick={() => {
            oneClickOperateMess(2)
            Modal.clear()
          }} style={{ backgroundColor: 'var(--MainColor)', width: '183px', height: '44px', color: 'white', fontSize: '15px', textAlign: 'center', borderRadius: '22px', lineHeight: '44px', marginTop: '10px' }}>确认</div>
          <div onClick={() => {
            Modal.clear()
          }} style={{ fontSize: '13px', color: '#999', paddingTop: '10px' }}>取消</div>
        </div>
      ),
    })
  }

  const oneClickOperateMess = (operate_type) => {
    general.axios.post('/oneClickOperateMess', {
      general_type: props.query.type,
      operate_type: operate_type,
      subtype: array[activeIndex].subtype
    }).then(res => {
      let { status, data } = res.data;
      if (!status.succeed) {
        Dialog.error(status.error_desc);
        return;
      }
      if (operate_type == 1) {
        redux.dispatch({
          type: 'readAllMessage',
          data: {
            readAllType: array[activeIndex].subtype
          }
        })
      } else if (operate_type == 2) {
        redux.dispatch({
          type: 'deleteAllMessage',
          data: {
            deleteAllType: array[activeIndex].subtype
          }
        })
      }
    })
  }

  useEffect(() => {
    if (props.active) {
      props.setOperate(<div onClick={() => setVisible(true)}>编辑</div>)
    }
  }, [props.active])

  useEffect(() => {
    if (props.active) {
      if (props.query.type === 'system') {
        setArray([
          { id: 0, name: '全部', subtype: 'all' },
          { id: 1, name: '官方', subtype: 'system_announcement' },
          { id: 2, name: '到期', subtype: 'system_expire' },
          { id: 3, name: '招募', subtype: 'system_recruit' },
          { id: 4, name: '荣耀会员', subtype: 'system_honor' },
        ])
      } else if (props.query.type === 'community') {
        setArray([
          { id: 0, name: '全部', subtype: 'all' },
          { id: 1, name: '回复', subtype: 'community_reply' },
          { id: 2, name: '点赞', subtype: 'community_like' },
          { id: 3, name: '评优', subtype: 'community_quality' },
        ])
      } else if (props.query.type === 'trade') {
        setArray([
          { id: 0, name: '全部', subtype: 'all' },
          { id: 1, name: '小号交易', subtype: 'trade_offer' },
          { id: 2, name: '议价', subtype: 'trade_bargaining' },
        ])
      } else if (props.query.type === 'rebate') {
        setArray([
          { id: 0, name: '全部', subtype: 'all' },
          { id: 1, name: '审核通过', subtype: 'rebate_audit_rejected' },
          { id: 2, name: '审核驳回', subtype: 'rebate_audit_approved' },
        ])
      }
    }
  }, [props.active, props.query.type])

  useEffect(() => {
    if (array.length > 0 && props.active) {
      props.setTitle(<div style={{ display: 'flex', alignItems: 'center' }}>
        {array.map(item => <span
          onClick={() => setActiveIndex(item.id)}
          key={item.id}
          style={{
            marginRight: '20px',
            fontWeight: '500',
            fontSize: activeIndex == item.id ? '19px' : `16px`,
            color: activeIndex == item.id ? '#282828' : '#666',
          }}>{item.name}</span>)}
      </div>)
    }
  }, [props.active, array, activeIndex])

  return (
    <div>
      <div>
        {array.map(item => <div
          style={{ display: activeIndex == item.id ? 'block' : 'none' }}
          key={item.id}>
          <MessageList
            active={activeIndex == item.id && props.active}
            general_type={props.query.type}
            subtype={item.subtype}
          ></MessageList>
        </div>)}
      </div>
      <ActionSheet
        cancelText='取消'
        popupClassName='message-action-sheet'
        getContainer={document.getElementById('root')}
        closeOnAction={true}
        visible={visible}
        actions={actions}
        onClose={() => setVisible(false)}
      />
    </div>
  )
}
